var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFantom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#13B5EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9 9.675L15.6 8.1V11.25L12.9 9.675ZM15.6 16.425L12 18.525L8.4 16.425V12.75L12 14.85L15.6 12.75V16.425ZM8.4 8.1L11.1 9.675L8.4 11.25V8.1ZM12.45 10.425L15.15 12L12.45 13.575V10.425ZM11.55 13.575L8.85 12L11.55 10.425V13.575ZM15.15 7.35L12 9.15L8.85 7.35L12 5.475L15.15 7.35ZM7.5 7.05V16.875L12 19.425L16.5 16.875V7.05L12 4.5L7.5 7.05Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFantom);
export default __webpack_public_path__ + "static/media/fantom.ad3ac22338e43731c239485b7dacf82b.svg";
export { ForwardRef as ReactComponent };